module.exports = require("vue2-ace-editor");